import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/theme.js"; // Optional global styles import if you have css

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
